module.exports = __webpack_public_path__ + "static/media/ZILLASLAB-LIGHTITALIC_0.8522181f.OTF";